import eventBus from '../plugins/eventBus'
import { UserModel } from './models/UserModel'

if (eventBus.$store.state.user.isLogged) {
  console.log('is logged')
}

export default {}
